
  import Vue, {PropType} from "vue";
  import PwaCompetitionAwardsTree from "@/components/competitions/PwaCompetitionAwards/PwaCompetitionAwardsTree.vue";
  import {COMPETITION_STATUS_ID} from "@/utils/competition";

  export default Vue.extend({
    name: "pwa-competition-awards",
    components: {
      PwaCompetitionAwardsTree,
      PwaAccordion: () => import("@/components/common/PwaAccordion.vue"),
    },
    props: {
      pyramid: {
        type: Object,
        required: true,
      },
      isUserInCompetition: {
        type: Boolean,
        required: true,
      },
      competitionStatusId: {
        type: Number,
        required: true,
      },
      dateRounds: {
        type: Array as PropType<any[]>,
        required: false,
        default: null,
      },
    },
    computed: {
      isCompetitionPending(): boolean {
        return this.competitionStatusId === COMPETITION_STATUS_ID.PENDING;
      },
      isCompetitionConfirmed(): boolean {
        return this.competitionStatusId === COMPETITION_STATUS_ID.CONFIRMED;
      },
    },
  });
